/* SST Theme — global behavior: mobile nav drawer + footer accordion sync. */
(function () {
  var page = document.querySelector('.sst-page');
  var menuBtn = document.querySelector('[data-sst-menu-toggle]');
  var closeTargets = document.querySelectorAll('[data-sst-menu-close]');

  function setMenuOpen(open) {
    if (!page) return;
    page.toggleAttribute('data-sst-menu-open', open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      setMenuOpen(menuBtn.getAttribute('aria-expanded') !== 'true');
    });
  }
  closeTargets.forEach(function (el) {
    el.addEventListener('click', function () { setMenuOpen(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenuOpen(false);
  });

  window.addEventListener('pageshow', function () {
    setMenuOpen(false);
  });

  // Header cart icon opens the cart drawer (kept off Dawn's own
  // #cart-icon-bubble id so its section-swap never overwrites our icon).
  var cartIcon = document.querySelector('[data-sst-cart-icon]');
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartIcon && cartDrawer) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.open(cartIcon);
    });
  }

  // Logo-on-scroll: swap text/default logo for the scroll logo past a threshold.
  var header = document.querySelector('[data-sst-header][data-scroll-logo="true"]');
  if (header) {
    var offset = parseInt(header.getAttribute('data-scroll-logo-offset'), 10) || 0;
    var buffer = 12;
    var isScrolled = header.hasAttribute('data-scrolled');
    var ticking = false;
    var setScrolled = function () {
      var nextScrolled = isScrolled;
      if (window.scrollY > offset + buffer) nextScrolled = true;
      if (window.scrollY < Math.max(0, offset - buffer)) nextScrolled = false;
      if (nextScrolled !== isScrolled) {
        isScrolled = nextScrolled;
        header.toggleAttribute('data-scrolled', isScrolled);
      }
      ticking = false;
    };
    var requestScrolled = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setScrolled);
    };
    setScrolled();
    window.addEventListener('scroll', requestScrolled, { passive: true });
  }

  // Footer <details> groups open/close together.
  var groups = document.querySelectorAll('.sst-footer__group');
  var syncing = false;
  groups.forEach(function (group) {
    group.addEventListener('toggle', function () {
      if (syncing) return;
      syncing = true;
      groups.forEach(function (other) {
        if (other !== group) other.open = group.open;
      });
      syncing = false;
    });
  });

  // iOS Low Power Mode blocks muted autoplay; start those videos on the first touch instead.
  document.addEventListener('touchstart', function () {
    document.querySelectorAll('video[autoplay][muted]').forEach(function (video) {
      if (video.paused) video.play().catch(function () {});
    });
  }, { once: true, passive: true });
})();
